<template>
  <div>
    <div
      class="min-height-confirmation d-flex flex-column justify-content-center align-items-center"
    >
      <div>
        <img src="@/assets/icons/square-list.svg" />
      </div>
      <div class="color-primary-4 font-29 font-weight-bold">
        {{ $t('RequestCreatedSuccessfully') }}
      </div>
      <div class="font-16 d-flex flex-column align-items-center">
        <span class="color-primary-8">
          {{ $t('YourRequestNumberIs') }}:
          <span class="color-primary-6 font-weight-bold">
            {{ requestNumber }}
          </span>
        </span>
        <div class="mt-3">
          <div class="fw-bold font-22 font-weight-bold text-center">
            {{ $t('Atention') }}
          </div>
          <div class="color-primary-8 text-center font-weight-bold">
            {{ $t('RequestPendingSubmission') }}.
          </div>
          <div class="color-primary-8 text-center">
            {{ $t('RememberAccessRequestToSubmitMessage') }}
            <span class="font-weight-bold">
              {{ $t('FnLnkStatusNew') | upper }}
            </span>
            .
          </div>
        </div>
      </div>
      <div class="d-flex mt-3">
        <action-button
          :text="$t('DownloadYourRequest')"
          class="warning outline-warning px-4 py-2 mr-2"
          i="fa fa-download"
          @click="onDownloadRequestReportHandler"
        />
        <action-button
          :text="$t('ViewYourRequest')"
          class="btn-success px-4 py-2 mr-2"
          i="fa fa-list"
          @click="goToViewRequest"
        />
      </div>
    </div>
  </div>
</template>

<script>
//libs
import ActionButton from 'ActionButton';
import { getInvestigationRequestReport } from '@/services/report.api';
import { convertToBlob } from '@/utils/utilities';

export default {
  name: 'RequestConfirmation',
  components: {
    ActionButton,
  },
  props: {
    requestNumber: {
      type: String,
      default: '',
    },
  },
  methods: {
    goToViewRequest() {
      location.replace(`/request/${this.requestNumber}`);
    },
    async onDownloadRequestReportHandler() {
      if (this.requestNumber) {
        const response = await getInvestigationRequestReport(
          this.requestNumber,
          this.isEnLang
        ).catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
        if (response?.data) {
          convertToBlob(response.data);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';

.min-height-confirmation {
  min-height: 65vh !important;
}
</style>
